import React from 'react';
import get_bundle from '../domain/get_bundle';
import Locale from '../domain/Locale';
import getPrivacyURL from '../domain/getPrivacyURL';
import HTMLComponent from './HTMLComponent';
import template from 'lodash/string/template';
import { t, props } from 'tcomb-react';
import Cookies from 'cookies-js';

@props({
  locale: Locale,
  doAcceptCookies: t.maybe(t.Func)
})
export default class CookiesDisclaimer extends React.Component {

  areCookiesAccepted() {
    return Cookies.get('accept_cookies');
  }

  doAcceptCookies = (evt) => {
    evt.preventDefault();

    if (this.props.doAcceptCookies && !this.areCookiesAccepted()) {
      this.props.doAcceptCookies();
    }
  };

  render() {
    if (!this.props.doAcceptCookies) {
      return null;
    }

    const bundle = get_bundle(this.props.locale).footer.cookies_disclaimer;
    const description = template(bundle.description)({
      privacy_url: getPrivacyURL()
    });

    if (this.areCookiesAccepted()) {
      return null;
    }

    return (
      <div id='cookies_disclaimer'>
        <p>
          <HTMLComponent>
            {description}
          </HTMLComponent>
        </p>
        <button id='do_accept_cookies' onClick={this.doAcceptCookies} className='small'>{bundle.do_accept_cookies}</button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/CookiesDisclaimer.js
 **/